import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { FormService } from '../shared/form.service';

@Injectable({
  providedIn: 'root'
})
export class CheckOwnerGuard implements CanActivate {
  constructor(public formService: FormService, public router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const formData = this.formService?.currentForm?.getRawValue();
    if (formData.samePerson === 'Y') {
      return of(this.router.createUrlTree(['summary']));
    }
    return true;
  }

}
